import { ArrowUpTrayIcon } from "@heroicons/react/24/outline";
import React from "react";

interface ImportPreviousConversationButtonProps {
  onClick: () => void;
}

export const ImportPreviousConversationButton: React.FC<
  ImportPreviousConversationButtonProps
> = ({ onClick }) => (
  <button
    type="button"
    data-testid="reboot-live-import-conversation-button"
    onClick={onClick}
    className="flex items-center gap-2.5 px-5 py-2.5 rounded-[6px] text-[14px] font-normal transition-all border border-orange-500/40 bg-orange-500/[0.08] text-white hover:border-orange-500 hover:bg-orange-500/15 shadow-[0px_0px_12px_0px_rgba(251,106,7,0.08)]"
  >
    <ArrowUpTrayIcon className="w-4 h-4 text-orange-500" />
    Import Previous Conversation
  </button>
);
